import { RefundsPaymentMethodConfigInterface } from '../../../interfaces/dto/refunds-payment-method-config/refunds-payment-method-config-interface';
import { CpRefundsPaymentMethodModel } from '../refunds-payment-method/cp-refunds-payment-method-model';

export class CpRefundsPaymentMethodConfigModel implements RefundsPaymentMethodConfigInterface {
  PaymentMethodCodes: string[] = new Array<string>();
  PaymentMethods: CpRefundsPaymentMethodModel[] = new Array<CpRefundsPaymentMethodModel>();

  constructor(init?: Partial<CpRefundsPaymentMethodConfigModel>) {
    Object.assign(this, init);
  }
}
